import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { class: "gutter-y-s3" }
const _hoisted_3 = { class: "caption" }
const _hoisted_4 = { class: "flex dialog-detail align-items-center justify-content-between mt-s2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-s1" }, "/", -1)
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "dialog-data mt-s2 flex-center" }
const _hoisted_10 = {
  key: 1,
  class: "flex-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted mx-s1" }, "/", -1)
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "caption" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "mr-s1" }
const _hoisted_17 = { class: "text-default" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 0,
  class: "flex text-sm panel-info align-items-center justify-content-between py-s2 mt-s2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, "1234", -1)
const _hoisted_21 = { class: "dialog-footer dialog-footer-two-btn" }

import { useI18n } from 'vue-i18n';
import { TokenAmount } from '@/sdk/entities/fractions/tokenAmount';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { safeParseUnits } from '@/helpers/utils';
import { ref, computed } from 'vue';
import PriceImpactErrorMessage from '@/views/pages/liquidity/single-side/components/PriceImpactErrorMessage.vue';
import Caption from '@/components/Caption.vue';
import { format, printUSD } from '@/utils/format';
import BigNumber from 'bignumber.js';
import LossConfirmationDialog from '@/views/pages/liquidity/single-side/components/LossConfirmationDialog.vue';
import { SingleSideWithdrawForm } from '@/store/modules/single-side/models/single-side-withdraw-form';
import LpAmountFormat from '@/components/LpAmountFormat.vue';
import { BIG_ZERO } from '@/utils/bigNumber';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenWithdrawConfirmation',
  props: {
    tokenForm: null
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'cancel'): void;
  (e: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tokenForm: SingleSideWithdrawForm;
}





const { t } = useI18n();
const amountStrToSignificant = (token, amount) => {
  return new TokenAmount(token, safeParseUnits(amount, token.decimals)).toSignificant(8);
};

const isLpTokensAmount = computed(() => !!props.tokenForm.estimatedWithdrawInToken);
const isPriceImpactError = computed(() => {
  return !!props.tokenForm.errors['PRICE_IMPACT'];
});
const isCrosschain = computed(() => props.tokenForm.input.token?.isCrossChain);

//LOSS
const isNeedLossConfirmation = computed(() => !!props.tokenForm.errors['HUGE_LOSS']);
const lossPanelClass = computed(() => (isNeedLossConfirmation.value ? 'warning' : 'success'));
const isLoss = computed(() => !props.tokenForm.lossInUSD.eq(0));
const isLossConfirmationDialog = ref(false);

// FORMAT VALUE
const formatValueInPercent = (value: BigNumber) => {
  return value.lt(0.01) ? `<0.01 %` : `${format(value.toFixed(2))} %`;
};

const onConfirm = () => {
  emits('confirm');
};

const onShowLossConfirmation = () => {
  isLossConfirmationDialog.value = true;
};
const onCloseLossConfirmation = () => {
  isLossConfirmationDialog.value = false;
};
const onClickConfirm = () => {
  isNeedLossConfirmation.value ? onShowLossConfirmation() : onConfirm();
};

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('singleSide.confirmDialog.withdraw.youReceive')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TokenIcon, {
              "icon-src": __props.tokenForm.input.token?.portfolioToken.tokenIconUrl,
              symbol: __props.tokenForm.input.token?.portfolioToken.symbol,
              "chain-id": __props.tokenForm.input.token?.portfolioToken.chainId,
              size: "20",
              full: ""
            }, null, 8, ["icon-src", "symbol", "chain-id"]),
            (_unref(isLpTokensAmount))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", null, _toDisplayString(amountStrToSignificant(
                  __props.tokenForm.input.token?.portfolioToken,
                  __props.tokenForm.estimatedWithdrawInToken,
                )), 1),
                  _hoisted_6,
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(printUSD)(__props.tokenForm.estimatedWithdrawInUSD)), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_Skeleton, { width: "4.5rem" })
                ]))
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(Caption, {
            caption: _unref(t)('singleSide.confirmDialog.withdraw.lpTokensYouSpend.caption'),
            "with-formatted-text": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(t)('singleSide.confirmDialog.withdraw.lpTokensYouSpend.tooltip.fromFarm', {
                tokensFromFarm: _unref(format)(__props.tokenForm.amountLPFromFarm ?? _unref(BIG_ZERO)),
              })), 1),
              _createElementVNode("div", null, _toDisplayString(_unref(t)('singleSide.confirmDialog.withdraw.lpTokensYouSpend.tooltip.fromWallet', {
                tokensFromWallet: _unref(format)(__props.tokenForm.amountLPFromWallet ?? _unref(BIG_ZERO)),
              })), 1)
            ]),
            _: 1
          }, 8, ["caption"]),
          _createElementVNode("div", _hoisted_9, [
            (!_unref(isLpTokensAmount))
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  class: "w-8rem"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(LpAmountFormat, {
                    "lp-amount": __props.tokenForm.amountLP ?? _unref(BIG_ZERO)
                  }, null, 8, ["lp-amount"]),
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString(__props.tokenForm.amountLPInUSD ? _unref(printUSD)(__props.tokenForm.amountLPInUSD) : '-'), 1)
                ]))
          ])
        ]),
        (_unref(isLoss))
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('singleSide.confirmDialog.fee')), 1),
              (_unref(isPriceImpactError))
                ? (_openBlock(), _createBlock(PriceImpactErrorMessage, {
                    key: 0,
                    class: "mt-s2"
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(`panel-message-${_unref(lossPanelClass)} flex align-items-center justify-content-between mt-s2`)
                    }, [
                      _createElementVNode("div", null, _toDisplayString(_unref(t)('singleSide.confirmDialog.feeAndPriceImpact')), 1),
                      (_unref(isLoss))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(printUSD)(__props.tokenForm.lossInUSD)), 1),
                            _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(formatValueInPercent(__props.tokenForm.lossPercent)) + ")", 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(_component_Skeleton, { width: "4.5rem" })
                          ]))
                    ], 2),
                    (_unref(isCrosschain))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(Caption, {
                            caption: _unref(t)('singleSide.confirmDialog.crosschainFee.caption'),
                            tooltip: _unref(t)('singleSide.confirmDialog.crosschainFee.tooltip')
                          }, null, 8, ["caption", "tooltip"]),
                          _hoisted_20
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _unref(t)('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)('singleSide.confirmDialog.withdraw.confirmButtonLabel'),
        onClick: onClickConfirm
      }, null, 8, ["label"])
    ]),
    (isLossConfirmationDialog.value)
      ? (_openBlock(), _createBlock(LossConfirmationDialog, {
          key: 0,
          onConfirm: onConfirm,
          onCancel: onCloseLossConfirmation,
          "price-impact": _unref(format)(__props.tokenForm.lossPercent),
          "totally-provide": _unref(format)(__props.tokenForm.estimatedWithdrawInUSD),
          "potential-loss": _unref(format)(__props.tokenForm.lossInUSD)
        }, null, 8, ["price-impact", "totally-provide", "potential-loss"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})